import { MutationTree } from "vuex";
import { StatisticState, WhatsappDetailItem, WhatsappGroupItem } from "./types";

export const mutations: MutationTree<StatisticState> = {
  setWhatsappStatisticDetail: (state, data: WhatsappDetailItem[]) => state.whatsappStatisticDetail = data,
  pushWhatsappStatisticDetail: (state, data: WhatsappDetailItem[]) => state.whatsappStatisticDetail = state.whatsappStatisticDetail.concat(data),
  setWhatsappStatisticDetailFlag: (state, flag: string) => state.whatsappStatisticDetailFlag = flag,
  // setWhatsappMessagesCount: (state, count: number) => state.whatsappStatisticGroupMessageCount = count,
  setWhatsappStatisticGroup: (state, data: WhatsappGroupItem[]) => state.whatsappStatisticGroup = data,
};